import { useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import { ITooltip } from '../../../components/1elements';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../../services/context/DataContext';
import { ReactComponent as FilterButton } from '../../../components/1elements/Icons/svg/heatMap/settingsButton.svg';

const HMapSettingButton = ({ className }) => {
  const { activeTabData } = useContext(GlobalContext);
  const [, setActiveTab] = activeTabData;
  const classes = useStyles();
  const navigate = useNavigate();

  const sendToMapConfiguration = () => {
    navigate('/adminDashboard');
    setActiveTab('83');
  };

  return (
    <div className={className}>
      <ITooltip placement={'left'} content={'Map Configuration'}>
        <div
          className={`${classes.root} ${className}`}
          onClick={sendToMapConfiguration}
        >
          <FilterButton />
        </div>
      </ITooltip>
    </div>
  );
};

export default HMapSettingButton;

const useStyles = makeStyles((theme) => ({
  root: {
    width: '40px',
    height: '40px',
    padding: '8px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '12px',
    border: `1px solid ${theme.palette.quaternary.main}`,
    transition: 'border 0.3s ease-in-out',
    boxShadow: '0px 0px 6px #00000029',
    '&:hover': {
      border: `1px solid ${theme.palette.secondary.accent}`,
      cursor: 'pointer'
    }
  }
}));
